"use strict";
//Pulled out of material ui
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointKeys = void 0;
exports.breakpointKeys = ["xs", "sm", "md", "lg", "xl"];
// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
    const { 
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
    }, unit = "px", step = 5 } = breakpoints, other = __rest(breakpoints, ["values", "unit", "step"]);
    const keys = Object.keys(values);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const endIndex = keys.indexOf(key) + 1;
        const upperbound = values[keys[endIndex]];
        if (endIndex === keys.length) {
            // xl down applies to all sizes
            return up("xs");
        }
        const value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        if (endIndex === keys.length - 1) {
            return up(start);
        }
        return (`@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` +
            `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex + 1]] === "number" ? values[keys[endIndex + 1]] : end) -
                step / 100}${unit})`);
    }
    function only(key) {
        return between(key, key);
    }
    function width(key) {
        return values[key];
    }
    return Object.assign({ keys,
        values,
        up,
        down,
        between,
        only,
        width }, other);
}
exports.default = createBreakpoints;
//# sourceMappingURL=createBreakpoints.js.map